import React from 'react';
import './AnalyticsSectionCard.css';
import { Box, Typography } from '@mui/material';

const AnalyticsSectionCard = ({ title, children }) => (
  <Box className="analytics-section-card">
    {title && (
      <Typography className="section-card-title" variant="subtitle1">
        {title}
      </Typography>
    )}
    <Box className="section-card-content">{children}</Box>
  </Box>
);

export default AnalyticsSectionCard;
